import Cookies from "js-cookie";

const TokenKey = "token";
const TenantKey = "Admin-Tenant";
const AdminTokenKey = "Admin-Token";
export function getToken() {
  let token: any = Cookies.get(TokenKey) || "";
  if (
    window.location.href.includes(process.env.VUE_APP_ADMIN) &&
    Cookies.get(AdminTokenKey)
  )
    token = Cookies.get(AdminTokenKey);
  return token;
}
export function removeToken() {
  localStorage.removeItem(TokenKey);
  return Cookies.remove(TokenKey);
}
export function getTenant() {
  return Cookies.get(TenantKey);
}
export function removeTenant() {
  return Cookies.remove(TenantKey);
}
